import React from 'react';
import { styled } from '@mui/material/styles';
import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, IconButton, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import useAuthStore from '../../store/useAuthStore';

// Icons
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ReceiptIcon from '@mui/icons-material/Receipt';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: 'space-between',
}));

const getDashboardPath = (role) => {
  switch (role) {
    case 'RANTING': return '/ranting-dashboard';
    case 'MWC': return '/mwc-dashboard';
    case 'LAZISNU': return '/lazisnu-dashboard';
    default: return '/login';
  }
};

const Sidebar = ({ open, handleDrawerClose }) => {
  const user = useAuthStore((state) => state.user);

  const lazisnuMenuItems = [
    { text: 'Dashboard', path: getDashboardPath(user?.role), icon: <DashboardIcon /> },
    { text: 'Transaksi Lazisnu', path: '/admin/transactions', icon: <ReceiptIcon /> },
    { text: 'Kinerja Global', path: '/admin/global-performance', icon: <AssessmentIcon /> },
    { text: 'Manajemen Unit', path: '/admin/units', icon: <AccountTreeIcon /> },
    { text: 'Manajemen Pengguna', path: '/admin/users', icon: <PeopleIcon /> },
  ];

  const mwcMenuItems = [
    { text: 'Dashboard', path: getDashboardPath(user?.role), icon: <DashboardIcon /> },
    { text: 'Transaksi Internal', path: '/mwc/transactions', icon: <ReceiptIcon /> },
    { text: 'Monitoring Ranting', path: '/mwc/monitor-ranting', icon: <VisibilityIcon /> },
    { text: 'Laporan Agregat', path: '/mwc/aggregated-report', icon: <AssessmentIcon /> },
  ];



  const getMenuItems = () => {
    const isLapangan = user?.jabatan === 'LAPANGAN';

    switch (user?.role) {
      case 'LAZISNU':
        if (isLapangan) {
          return [
            { text: 'Dashboard', path: getDashboardPath(user?.role), icon: <DashboardIcon /> },
            { text: 'Transaksi Lazisnu', path: '/admin/transactions', icon: <ReceiptIcon /> }
          ];
        }
        return lazisnuMenuItems;
      case 'MWC':
        if (isLapangan) {
          return [
            { text: 'Dashboard', path: getDashboardPath(user?.role), icon: <DashboardIcon /> },
            { text: 'Transaksi Internal', path: '/mwc/transactions', icon: <ReceiptIcon /> }
          ];
        }
        return mwcMenuItems;
      case 'RANTING':
        if (isLapangan) {
          return [
            { text: 'Dashboard', path: getDashboardPath(user?.role), icon: <DashboardIcon /> },
            { text: 'Input Transaksi', path: '/ranting/transactions/add', icon: <ReceiptIcon /> },
          ];
        }
        // Manajerial Ranting
        return [
          { text: 'Dashboard', path: getDashboardPath(user?.role), icon: <DashboardIcon /> },
          { text: 'Input Transaksi', path: '/ranting/transactions/add', icon: <ReceiptIcon /> },
          { text: 'Laporan Kinerja', path: '/ranting/report', icon: <AssessmentIcon /> },
        ];
      default: return [];
    }
  };

  const menuItems = getMenuItems();

  return (
    <Drawer
      sx={{ width: drawerWidth, flexShrink: 0, '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box' } }}
      variant="persistent"
      anchor="left"
      open={open}
    >
      <DrawerHeader>
        <Typography variant="h6" noWrap component="div" sx={{ pl: 1 }}>
          LazisNU App
        </Typography>
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding component={Link} to={item.path} sx={{ color: 'text.primary' }}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
